import React from "react";
import Analytics from "../../../helpers/analytics"
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
const Collections = () => (
  <Link
    id="collections-link"
    to="/licensing/collections"
    onClick={() => {
      Analytics.track("Collections", {
        category: "LP-TopNav",
      });
    }}
  >
    <Button>Collections</Button>
  </Link>
);

export default Collections;